export default {"src":"/_next/static/media/Lunato.82175261.svg","height":48,"width":88};